<template>
    <div :data-overlay="navOverlayBanner">
        <component
            :is="bannerComponent"
        />
    </div>
</template>

<script setup>
    const { digistormSettings, appId, getGlobalSetField } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    const primaryNavSettings = computed(() => {
        return first(getGlobalSetField.value('ds_Navigation_GlobalSet', 'primaryNav'))
    })

    const navOverlayBanner = computed(() => {
        if (get(entry.value, 'hideBanner')) {
            return false
        }

        return !primaryNavSettings.value?.primaryNav_ShowBackground
    })

    const bannerType = computed(() => {
        return digistormSettings.value.pageBannerType || 'internal-page-banner-default'
    })

    // check for any custom headers
    const customComponents = await import(`~/custom/${appId.value}/index.js`)
        .catch(() => {
            return null
        })

    const bannerComponent = computed(() => {
        if (bannerType.value === 'internal-page-banner-custom') {
            return customComponents?.default?.InternalBanner
        }

        return defineAsyncComponent(() => {
            // this can be removed after v0.3 release
            const type = bannerType.value === 'banner-default' ? 'internal-page-banner-default' : bannerType.value
            return import(`./page/${type}/banner.async.vue`)
        })
    })

</script>
